import React from "react";
import { string, number, node, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";

import "./contributor.m.css";

const Contributor = ({
  name,
  className = "",
  contributorType = 1,
  slug = "javascript:void(0)",
  role = "",
  authorDisplayName = "",
  publisherAttributes,
  authorObj
}) => {
  const PublicAuthor =
    authorObj.metadata && authorObj.metadata["Public Author"]
      ? authorObj.metadata["Public Author"].toLowerCase()
      : null;

  return (
    <div
      styleName={` base contributor-type-${contributorType}`}
      className={`${className} contributor-type-${contributorType}`}
    >
      {PublicAuthor === "yes" ? (
        <Link
          styleName={`contributor-name ${publisherAttributes.lang === "en" ? "en-contributor-name" : ""}`}
          className="contributor-name"
          href={slug}
        >
          {name}
        </Link>
      ) : (
        <span
          styleName={`contributor-name ${publisherAttributes.lang === "en" ? "en-contributor-name" : ""}`}
          className="contributor-name"
        >
          {name}
        </span>
      )}

      {role && (
        <span className="contributor-role" styleName={publisherAttributes.lang === "en" ? "en-contributor-role" : ""}>
          {role}
        </span>
      )}
    </div>
  );
};

Contributor.propTypes = {
  name: node,
  className: string,
  contributorType: number,
  slug: string,
  role: string,
  authorDisplayName: string,
  publisherAttributes: object,
  authorObj: object
};

const mapStateToProps = state => {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

export default connect(mapStateToProps, null)(Contributor);
